/** Rows-per-page choices for Query section list grids (Classic Paging.ascx parity). */
export const QUERY_LIST_PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100] as const;
